module.exports = __webpack_public_path__ + "img/Verband_Feldlager.1fda3172.svg";